import { getApiRoute } from './Config.js';
import axios from 'axios';

export async function sendMessage(message) {
    console.log('🤖 Processing message:', message);

    // Call the backend API (curriculum and students are loaded server-side)
    try {
      console.log('🌐 Calling backend Maestro service...');
      
      const response = await axios.post(
        getApiRoute("maestro", "CHAT"),
        { message }
      );

      if (response.data && response.data.response) {
        console.log('✅ Backend API response received');
        return {
          response: response.data.response,
          followUps: response.data.followUps || []
        };
      }
    } catch (error) {
      console.error('❌ Backend API error:', error);
      console.log('🔄 Service temporarily unavailable');
    }

    // Simple fallback if backend is unavailable
    return {
      response: "I'm temporarily unavailable. Please try again in a moment. If the issue persists, the teaching assistant service may be experiencing technical difficulties.",
      followUps: []
    };
}

